"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _lodash = _interopRequireDefault(require("lodash"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EventTemplateService = /*#__PURE__*/function () {
  function EventTemplateService() {
    _classCallCheck(this, EventTemplateService);
  }

  _createClass(EventTemplateService, null, [{
    key: "isAddEventTemplateRequestValid",
    value: function isAddEventTemplateRequestValid(addEventTemplateRequest) {
      if (addEventTemplateRequest === null || addEventTemplateRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        name: _joiBrowser["default"].string().min(2).max(50).required(),
        description: _joiBrowser["default"].string().min(0).max(1024).allow(''),
        defaultStartStatusId: _joiBrowser["default"].number().integer().allow(null),
        tags: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
        children: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
        eventData: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
        eventDataDefaultValues: _joiBrowser["default"].object().allow(null),
        dueDateWorkingTime: _joiBrowser["default"].object().allow(null),
        dueDateStatusChangeId: _joiBrowser["default"].number().integer().allow(null),
        allowActiveDuplicates: _joiBrowser["default"]["boolean"](),
        configurableTags: _joiBrowser["default"]["boolean"](),
        configurableName: _joiBrowser["default"]["boolean"](),
        configurableStartStatus: _joiBrowser["default"]["boolean"](),
        dueDateDefaultTime: _joiBrowser["default"].number(),
        dueDateDefaultTimeEndOfDay: _joiBrowser["default"]["boolean"]().allow(null),
        workflowStatuses: _joiBrowser["default"].array().items(_joiBrowser["default"].object().keys({
          statusId: _joiBrowser["default"].number(),
          startingStatus: _joiBrowser["default"]["boolean"](),
          requiredAssignment: _joiBrowser["default"]["boolean"]().allow(null),
          nextStatusOptions: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
          statusCommunication: _joiBrowser["default"].object().allow(null),
          order: _joiBrowser["default"].number().integer().allow(null)
        })).allow([]).allow(null),
        notificationChannels: _joiBrowser["default"].array().items(_joiBrowser["default"].string()).allow([]).allow(null)
      });

      return _joiBrowser["default"].validate(addEventTemplateRequest, schema).error === null;
    }
  }, {
    key: "isEditEventTemplateRequestValid",
    value: function isEditEventTemplateRequestValid(editEventTemplateRequest) {
      if (editEventTemplateRequest === null || editEventTemplateRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        name: _joiBrowser["default"].string().min(2).max(50).allow(null),
        description: _joiBrowser["default"].string().min(0).max(1024).allow(''),
        defaultStartStatusId: _joiBrowser["default"].number().integer().allow(null),
        tags: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
        children: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
        eventData: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
        eventDataDefaultValues: _joiBrowser["default"].object().allow(null),
        dueDateWorkingTime: _joiBrowser["default"].object().allow(null),
        dueDateStatusChangeId: _joiBrowser["default"].number().integer().allow(null),
        archived: _joiBrowser["default"]["boolean"]().allow(null),
        allowActiveDuplicates: _joiBrowser["default"]["boolean"]().allow(null),
        configurableTags: _joiBrowser["default"]["boolean"]().allow(null),
        configurableName: _joiBrowser["default"]["boolean"]().allow(null),
        configurableStartStatus: _joiBrowser["default"]["boolean"]().allow(null),
        dueDateDefaultTime: _joiBrowser["default"].number().allow(null),
        dueDateDefaultTimeEndOfDay: _joiBrowser["default"]["boolean"]().allow(null),
        workflowStatuses: _joiBrowser["default"].array().items(_joiBrowser["default"].object().keys({
          statusId: _joiBrowser["default"].number().allow(null),
          startingStatus: _joiBrowser["default"]["boolean"]().allow(null),
          requiredAssignment: _joiBrowser["default"]["boolean"]().allow(null),
          nextStatusOptions: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).allow(null),
          statusCommunication: _joiBrowser["default"].object().allow(null),
          order: _joiBrowser["default"].number().integer().allow(null)
        })).allow([]).allow(null),
        notificationChannels: _joiBrowser["default"].array().items(_joiBrowser["default"].string()).allow([]).allow(null)
      });

      return _joiBrowser["default"].validate(editEventTemplateRequest, schema).error === null;
    }
  }, {
    key: "isAddEventRequestValid",
    value: function isAddEventRequestValid(addEventRequest) {
      if (addEventRequest === null || addEventRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        startingStatusComment: _joiBrowser["default"].string().min(0).max(1024).allow(''),
        startingStatusId: _joiBrowser["default"].number().integer().allow(null),
        description: _joiBrowser["default"].string().min(0).max(1024).allow(''),
        tags: _joiBrowser["default"].array().items(_joiBrowser["default"].number().integer()).required().required(),
        eventData: _joiBrowser["default"].object().allow(null),
        name: _joiBrowser["default"].string().min(2).max(50).allow(null),
        dueDate: _joiBrowser["default"].date().allow(null),
        assignment: _joiBrowser["default"].string().min(0).max(1024).allow('').allow(null)
      });

      return _joiBrowser["default"].validate(addEventRequest, schema).error === null;
    }
  }, {
    key: "getEventTemplates",
    value: function getEventTemplates(includeArchived, pagination) {
      var url = "?includeArchived=".concat(includeArchived, "&page=").concat(pagination.page, "&size=").concat(pagination.size, "&search=").concat(pagination.search);

      _lodash["default"].forEach(pagination.sort, function (value) {
        url = url.concat("&sort=".concat(value));
      });

      return this.httpService.get(url);
    }
  }, {
    key: "getEventTemplateSubscriptions",
    value: function getEventTemplateSubscriptions(eventTemplateId) {
      if (!Number.isInteger(eventTemplateId)) {
        return Promise.reject(new Error('Missing Event Template ID'));
      }

      return this.httpService.get("/".concat(eventTemplateId, "/subscriptions"));
    }
  }, {
    key: "searchEventTemplates",
    value: function searchEventTemplates(includeArchived, request) {
      var _this = this;

      if (!request) {
        return Promise.reject(new Error('Invalid search event templates request'));
      }

      return new Promise(function (resolve) {
        _this.httpService.post("/search?includeArchived=".concat(includeArchived), request).then(function (response) {
          resolve(response);
        });
      });
    }
  }, {
    key: "addEventTemplate",
    value: function addEventTemplate(addEventTemplateRequest) {
      var _this2 = this;

      if (!EventTemplateService.isAddEventTemplateRequestValid(addEventTemplateRequest)) {
        return Promise.reject(new Error('Invalid add event template request'));
      }

      return new Promise(function (resolve, reject) {
        _this2.httpService.post('/', addEventTemplateRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "editEventTemplate",
    value: function editEventTemplate(eventTemplateId, editEventTemplateRequest) {
      var _this3 = this;

      if (!Number.isInteger(eventTemplateId)) {
        return Promise.reject(new Error('Missing Event Template ID'));
      }

      if (!EventTemplateService.isEditEventTemplateRequestValid(editEventTemplateRequest)) {
        return Promise.reject(new Error('Invalid edit event template request'));
      }

      return new Promise(function (resolve, reject) {
        _this3.httpService.patch("/".concat(eventTemplateId), editEventTemplateRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "deleteEventTemplate",
    value: function deleteEventTemplate(eventTemplateId) {
      var _this4 = this;

      if (!Number.isInteger(eventTemplateId)) {
        return Promise.reject(new Error('Missing Event Template ID'));
      }

      return new Promise(function (resolve, reject) {
        _this4.httpService["delete"]("/".concat(eventTemplateId)).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "addEventFromTemplate",
    value: function addEventFromTemplate(eventTemplateId, addEventRequest) {
      var _this5 = this;

      if (!Number.isInteger(eventTemplateId)) {
        return Promise.reject(new Error('Missing Event Template ID'));
      }

      if (!EventTemplateService.isAddEventRequestValid(addEventRequest)) {
        return Promise.reject(new Error('Invalid create event request'));
      }

      return new Promise(function (resolve, reject) {
        _this5.httpService.post("/".concat(eventTemplateId, "/events"), addEventRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "getEventTemplate",
    value: function getEventTemplate(id) {
      return this.httpService.get("/".concat(id));
    }
  }]);

  return EventTemplateService;
}();

exports["default"] = EventTemplateService;
EventTemplateService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_EVENT_API : '', "/eventTemplates")
});